<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<!--
				<div class="mb-3">
					<label class="form-label">Zakwaterowanie</label>
					<div class="row g-2">
						<div class="col-md">
							<input type="date" class="form-control" name="filters.departureFromFirstStop_from" [(ngModel)]="filters.departureFromFirstStop_from" id="departureFromFirstStop_from">
						</div>
						<div class="col-md">
							<input type="date" class="form-control" name="filters.departureFromFirstStop_to" [(ngModel)]="filters.departureFromFirstStop_to">
						</div>
					</div>
				</div>
				<div class="mb-3">
					<label class="form-label" for="filters.name">Status</label>
					<select class="form-control" [(ngModel)]="filters.status" placeholder="Status">
						<option value="">(wszystkie)</option>
						<option *ngFor="let item of statuses" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
				<div class="mb-3">
					<label class="form-label">Opiekun</label>
					<ng-select
						id="owner" name="owner" [(ngModel)]="filters.owner"
						[items]="users" bindLabel="name" bindValue="id"
						placeholder="Opiekun"
					></ng-select>
				</div>
-->
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="col-sm-4">
						<button type="button" class="btn btn-secondary" (click)="filtersClear()">Wyczyść filtry</button>
					</div>
					<div class="col-sm-8 text-end">
						<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
						<button
							type="button"
							class="btn btn-secondary"
							(click)="filtersClose()"
							data-bs-dismiss="modal"
						>
							Anuluj
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
